import React from 'react';
import { Box } from '@mui/material';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PurposeDashboard from '../../pages/PurposeDashboard';
import FunctionDashboard from '../../pages/FunctionDashboard';
import TermsAndPrivacy from '../../pages/TermsAndPrivacy';
import Sitemap from '../../pages/Sitemap';
import HowToUse from '../../pages/HowToUse';
import AdminDashboard from '../../pages/AdminDashboard';
import TVDemoPage from '../../pages/TVDemoPage';
import { detectLanguageFromPathname } from '../../i18n';
import { featureFlags } from '../../config/featureFlags';
import { MEIDAISAI_PREFIX } from '../../config/meidaisaiDemo';

function functionPathWithTvUtm(search) {
  const params = new URLSearchParams(search || '');
  if (params.get('utm_source') !== 'tv') {
    params.set('utm_source', 'tv');
  }
  const qs = params.toString();
  return `/function?${qs}`;
}

/** useUrlSync が / にクエリを付けたあと Navigate が再実行されない問題を避ける */
const RootRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // テレビ QR（utm_source=tv）はグラフベースへ直通
  if (params.get('utm_source') === 'tv') {
    return <Navigate to={functionPathWithTvUtm(location.search)} replace />;
  }
  return <Navigate to={`/purpose${location.search}`} replace />;
};

const EnglishRootRedirect = () => {
  const location = useLocation();
  return <Navigate to={`/en/purpose${location.search}`} replace />;
};

const MeidaisaiRootRedirect = () => {
  const location = useLocation();
  return <Navigate to={`${MEIDAISAI_PREFIX}/purpose${location.search}`} replace />;
};

const TvToFunctionRedirect = () => {
  const location = useLocation();
  return <Navigate to={functionPathWithTvUtm(location.search)} replace />;
};

const MeidaisaiInvalidRouteRedirect = () => (
  <Navigate to={`${MEIDAISAI_PREFIX}/purpose`} replace />
);

const InvalidEnglishRouteRedirect = () => {
  const location = useLocation();
  if (!featureFlags.english) {
    return <Navigate to="/purpose" replace />;
  }
  const isEnglish = detectLanguageFromPathname(location.pathname) === 'en';
  return <Navigate to={isEnglish ? '/en/purpose' : '/purpose'} replace />;
};

const Main = () => {
  return (
    <Box
      component="main"
      sx={{
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        {featureFlags.english && <Route path="/en" element={<EnglishRootRedirect />} />}
        <Route path="/tv" element={<TvToFunctionRedirect />} />
        <Route path="/purpose" element={<PurposeDashboard />} />
        {featureFlags.english && <Route path="/en/purpose" element={<PurposeDashboard />} />}
        <Route path="/function" element={<FunctionDashboard />} />
        {featureFlags.english && <Route path="/en/function" element={<FunctionDashboard />} />}
        <Route path="/terms" element={<TermsAndPrivacy />} />
        {featureFlags.english && <Route path="/en/terms" element={<TermsAndPrivacy />} />}
        <Route path="/sitemap" element={<Sitemap />} />
        {featureFlags.english && <Route path="/en/sitemap" element={<Sitemap />} />}
        <Route path="/how-to-use" element={<HowToUse />} />
        {featureFlags.english && <Route path="/en/how-to-use" element={<HowToUse />} />}
        {featureFlags.admin && <Route path="/admin" element={<AdminDashboard />} />}
        {featureFlags.english && featureFlags.admin && <Route path="/en/admin" element={<AdminDashboard />} />}
        {featureFlags.tvDemo && <Route path="/tv-demo" element={<TVDemoPage />} />}
        {featureFlags.meidaisai && (
          <>
            <Route path={MEIDAISAI_PREFIX} element={<MeidaisaiRootRedirect />} />
            <Route path={`${MEIDAISAI_PREFIX}/purpose`} element={<PurposeDashboard />} />
            <Route path={`${MEIDAISAI_PREFIX}/function`} element={<FunctionDashboard />} />
            <Route path={`${MEIDAISAI_PREFIX}/terms`} element={<TermsAndPrivacy />} />
            <Route path={`${MEIDAISAI_PREFIX}/sitemap`} element={<Sitemap />} />
            <Route path={`${MEIDAISAI_PREFIX}/how-to-use`} element={<HowToUse />} />
            <Route path={`${MEIDAISAI_PREFIX}/*`} element={<MeidaisaiInvalidRouteRedirect />} />
          </>
        )}
        <Route path="*" element={<InvalidEnglishRouteRedirect />} />
      </Routes>
    </Box>
  );
};

export default Main;
